import { CommonProps } from '@/@types/common'
import classNames from 'classnames'
import { ElementType, forwardRef } from 'react'

interface ContainerProps extends CommonProps {
   asElement?: ElementType
}

const Container = forwardRef((props: ContainerProps, ref) => {
   const { className, children, asElement: Component = 'div', ...rest } = props

   return (
      <Component ref={ref} className={classNames('container mx-auto mb-[30px]', className)} {...rest}>
         {children}
      </Component>
   )
})

Container.displayName = 'Container'

export default Container
